//issue 257
import moment from 'moment';
//issue 257
export default {

    "title": "User Logs",
    "entityName": "user_log",
    "pagination": {
        "rowsPerPage": 5,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    "fields": [
        {
            slim:true,
            value: "action",
            text: "Action",
            type: "text",
            table: {
                sortable: true,
                filter: true
            },
            validators: [
                "required"
            ]
        },
        {
            slim:true,
            value: "platform",
            text: "Platform",
            type: "list",
            list: ['REDCap', 'SafetyDB', 'eCDS', 'EMN Logistic'],
            table: {
                sortable: true,
                filter: true
            },
            validators: [
                "required"
            ]
        },
        {
            slim:true,
            value: "accouhnt_id",
            text: "Insert by",
            type: "text",
            table: { "filter": true },
            validators: [
                "required"
            ],
            render(item) { return item.account.first_name + ' ' + item.account.last_name }
        },
        {
            slim:true,
            value: "insert_at",
            text: "Insert at",
            type: "list",
            "item-id": "id",
            "item-text": "name",
            list: [],
            table: { },
            validators: [
                "required"
            ],
            //issue 257
            //issue 265
            render(item) { return moment(item.insert_at).format('DD-MMM-YYYY HH:mm:ss')  }
            //issue 265
            //issue 257
        },
          
    ],
    "actions": []
}